module.exports = __webpack_public_path__ + "static/media/home.422239f1.jpg";